import { useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { IconLock, IconAlertCircle, IconShieldCheck } from '@tabler/icons-react';
import api from '../api/api';

export default function ChangePasswordPage({ setIsLoggedIn }) {
  const navigate = useNavigate();
  const location = useLocation();
  const forced = location.state?.forced;
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password.length < 4) {
      setError('비밀번호는 4자 이상이어야 합니다.');
      return;
    }
    if (password !== confirmPassword) {
      setError('비밀번호가 일치하지 않습니다.');
      return;
    }
    setError('');
    setLoading(true);
    try {
      await api.patch('/auth/me', { password });
      setIsLoggedIn(true);
      navigate('/');
    } catch (err) {
      setError(err.response?.data?.message || '비밀번호 변경에 실패했습니다.');
      setLoading(false);
    }
  };

  const inputStyle = {
    paddingLeft: 38, height: 44, borderRadius: 10, fontSize: 14,
    border: '1.5px solid var(--tblr-border-color, #e6e7e9)',
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center',
      background: 'var(--tblr-bg-surface, #f4f6fa)',
    }}>
      <div style={{
        background: '#fff', borderRadius: 16, padding: '40px 36px',
        maxWidth: 420, width: '100%',
        boxShadow: '0 8px 32px rgba(0,0,0,0.1)',
      }}>
        <div style={{ textAlign: 'center', marginBottom: 24 }}>
          <div style={{
            width: 56, height: 56, borderRadius: 14,
            background: 'linear-gradient(135deg, #f59f00, #f76707)',
            color: '#fff',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            margin: '0 auto 16px',
          }}>
            <IconShieldCheck size={28} />
          </div>
          <h3 style={{ fontWeight: 700, fontSize: 20, marginBottom: 8 }}>비밀번호 변경</h3>
          <p style={{ fontSize: 14, color: '#868e96', lineHeight: 1.6 }}>
            {forced
              ? '임시 비밀번호로 로그인하셨습니다.\n새 비밀번호를 설정해주세요.'
              : '새 비밀번호를 입력하세요.'}
          </p>
        </div>

        {error && (
          <div className="alert alert-danger mb-3" style={{ borderRadius: 10, border: 'none', background: '#fff0f0', fontSize: 14 }}>
            <div className="d-flex align-items-center gap-2">
              <IconAlertCircle size={16} style={{ color: '#d63939', flexShrink: 0 }} />
              <span>{error}</span>
            </div>
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label className="form-label fw-medium" style={{ fontSize: 14 }}>새 비밀번호</label>
            <div style={{ position: 'relative' }}>
              <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: 'var(--tblr-muted)', pointerEvents: 'none' }}>
                <IconLock size={17} />
              </span>
              <input type="password" className="form-control form-control-sm" placeholder="새 비밀번호"
                value={password} onChange={e => setPassword(e.target.value)}
                autoFocus required style={inputStyle} />
            </div>
          </div>

          <div className="mb-4">
            <label className="form-label fw-medium" style={{ fontSize: 14 }}>비밀번호 확인</label>
            <div style={{ position: 'relative' }}>
              <span style={{ position: 'absolute', left: 12, top: '50%', transform: 'translateY(-50%)', color: 'var(--tblr-muted)', pointerEvents: 'none' }}>
                <IconLock size={17} />
              </span>
              <input type="password" className="form-control form-control-sm" placeholder="비밀번호 확인"
                value={confirmPassword} onChange={e => setConfirmPassword(e.target.value)}
                required style={inputStyle} />
            </div>
          </div>

          <button type="submit" disabled={loading} style={{
            width: '100%', height: 44, borderRadius: 10, fontSize: 15, fontWeight: 600,
            background: loading ? 'var(--tblr-muted)' : 'linear-gradient(135deg, var(--tblr-primary, #206bc4), #4263eb)',
            border: 'none', color: '#fff', cursor: loading ? 'not-allowed' : 'pointer',
            boxShadow: loading ? 'none' : '0 4px 12px rgba(32,107,196,0.35)',
            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8,
          }}>
            {loading ? (<><span className="spinner-border spinner-border-sm" style={{ width: 16, height: 16 }} /> 변경 중...</>) : '비밀번호 변경'}
          </button>
        </form>
      </div>
    </div>
  );
}
